import React from 'react';
import { Zap, User, Clock, CheckCircle } from 'lucide-react';
import { whyChooseUs } from '../mockData';

const iconMap = {
  Zap,
  User,
  Clock,
  CheckCircle
};

export const WhyChooseUs = () => {
  return (
    <section id="why-us" className="py-16 sm:py-20 lg:py-24 bg-gradient-to-br from-blue-600 to-blue-700 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            Warum M.A. Zulassungsdienst?
          </h2>
          <p className="text-lg text-blue-100 max-w-2xl mx-auto">
            Wir machen den Unterschied durch persönlichen Service und schnelle Bearbeitung
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {whyChooseUs.map((feature) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div 
                key={feature.id}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300 text-center"
              >
                <div className="w-16 h-16 bg-white rounded-xl flex items-center justify-center mx-auto mb-4 shadow-lg">
                  <IconComponent className="w-8 h-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2">
                  {feature.title}
                </h3>
                <p className="text-blue-100">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 text-center">
          <p className="text-xl text-white font-semibold">
            Kombination aus Zulassung + Versicherungsberatung für maximale Zeitersparnis
          </p>
        </div>
      </div>
    </section>
  );
};
